import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import { ListGroup } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Button, Collapse } from 'antd';

import { Income, Item } from '../types/Income';
import { CertificateDto } from '../types/Certificate';
import { baseUrl } from '../BaseUrl';

export default function IncomeDetails() {
    const { id } = useParams();

    const [income, setIncome] = useState<Income>();

    useEffect(() => {
        const getIncome = async () => {
            const response = await axios.get(baseUrl + "/api/Incomes/" + id,
                { withCredentials: true }
            );
            response.data.incomeDate = new Date(response.data.incomeDate);
            setIncome(response.data)
        };

        getIncome();
    }, [id]);


    const [linkedCertificates, setLinkedCertificates] = useState<Map<Item, CertificateDto>>(new Map<Item, CertificateDto>());

    const getLinkedCertificate = async (certificateId: string) => {
        const response = await axios.get(baseUrl + "/api/Certificates/" + certificateId,
            { withCredentials: true }
        );
        return response.data as CertificateDto;
    };
    
    const loc = useRef(linkedCertificates);
    useEffect(() => {
        const loadLinkedCertificates = async () => {
            if (income == null) {
                return;
            }
            for (const item of income.items) {
                const cert = await getLinkedCertificate(item.certificateId);
                console.log(cert);
                setLinkedCertificates(new Map(loc.current.set(item, cert)));
            }
        };

        loadLinkedCertificates();
    }, [income]);




    return income != null ? (
        <div className='page-container'>
            <Helmet>
                <title>{"Поступлениe " + income.incomeDate.toLocaleDateString()}</title>
            </Helmet>

            <h3 style={{ textAlign: "center", margin: "20px" }}>Поступлениe {income.incomeDate.toLocaleDateString()}</h3>
            <div style={{ display: "flex", justifyContent: "start" }}>
                <Box sx={{ height: "100%", width: '100%' }}>
                    <ListGroup>
                        <ListGroup.Item>
                            <div className="ms-2 me-auto">
                                <div className="fw-bold">Описание</div>
                                {income.description}
                            </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <div className="ms-2 me-auto">
                                <div className="fw-bold">Время поступления</div>
                                {income.incomeDate.toLocaleTimeString()}
                            </div>
                        </ListGroup.Item>

                        <ListGroup.Item>
                            <div className="fw-bold" style={{ margin: "10px" }}>Предметы: {income.items?.length}</div>
                            <ListGroup>
                                {income.items?.map((item) => (
                                    <ListGroup style={{ margin: "10px", border: "1px solid black" }}>
                                        <Collapse items={
                                            [
                                                {
                                                    key: '1',
                                                    label: <div style={{ display: "flex", alignItems: "center" }}>
                                                        <h5 style={{ textAlign: "left", margin: "5px", width: "50%" }}>
                                                            {item.name}
                                                        </h5>
                                                        <div className="ms-2 me-auto" style={{ width: "20%" }}>
                                                            <div>Количество: {item.quantity}</div>
                                                        </div>
                                                        <div className="ms-2 me-auto" style={{ width: "20%" }}>
                                                            <div>Размер: {item.size}</div>
                                                        </div>
                                                        <div className="ms-2 me-auto" style={{ width: "20%" }}>
                                                            <div>Фото: {item.photoUrls?.length}</div>
                                                        </div>
                                                        <div className="ms-2 me-auto" style={{ width: "30%" }}>
                                                            <div>Сертификат: {item.certificateId == null || !linkedCertificates.has(item) ? "Нет" :
                                                                 linkedCertificates.get(item)?.photos !== undefined && linkedCertificates.get(item)?.photos.length === 1 && linkedCertificates.get(item)?.photos[0].name.includes(".pdf") ?
                                                                    <Button style={{ width: "100%", height: "100%", overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "break-spaces"}} type='link' onClick={() => window.open(linkedCertificates.get(item)?.photos[0].url as string, "_blank")}>{linkedCertificates.get(item)?.name}</Button>
                                                                    :
                                                                    <Link style={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "break-spaces"}} to={"/Certificate/" + item.certificateId}>{linkedCertificates.get(item)?.name}</Link>}</div>
                                                        </div>
                                                    </div>,

                                                    children: <ListGroup.Item>
                                                        <div className="ms-2 me-auto">
                                                            <div className="images-container">
                                                                {item.photoUrls === undefined || item.photoUrls.length === 0 ? <div>Нет приложений</div> :
                                                                    item.photoUrls?.map((url, index) => (
                                                                        <div key={index} className="image-wrapper">
                                                                            <img src={url} alt="Certificate" />
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                    </ListGroup.Item>
                                                }
                                            ]
                                        }>
                                        </Collapse>

                                    </ListGroup>
                                ))}
                            </ListGroup>
                        </ListGroup.Item>
                    </ListGroup>
                </Box>
            </div >
        </div >
    ) : null
}